var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',{staticClass:"text-center"},[_c('Lottie',{attrs:{"options":_vm.defaultOptions,"height":250,"width":250},on:{"animCreated":_vm.handleAnimation}}),_c('h2',{class:[_vm.isSmallOrLower ? '' : 'mt-4']},[_c('PageLoaderQuotes')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }